import { getAccessToken } from "src/api/APIs"
import Notibar from "./Notibar"
import { getData, saveData } from "./localDataHandler";

export default async (callback) => {
    if (getData("bkv_token")) {
        await callback();
    } else {
        try {
            const res = await getAccessToken();
            const data = res.data;
            if (!data["AccessToken"] || !data["uuid"]) {
                throw new Error("Failed to initiate journey")
            } else {
                saveData("bkv_token", data["AccessToken"]);
                saveData("uuid", data["uuid"]);
                await callback();
            }
        } catch (e) {
            Notibar.error(e, "Failed to initiate journey")
        }
    }
}